import { BonusClassification, BonusSettlementSupplierStatus, BonusSettlementType } from '@synergy/models';

export interface BonusSettlementCustomerDetail {
    id: number;
    supplierId: number;
    supplierName: string;
    supplierCity?: string | null;
    status: BonusSettlementSupplierStatus;
    noteToCustomer?: string | null;
    bonusConditions: BonusCondition[];
    bonusClassification?: BonusClassification | null;
    type: BonusSettlementType;
}

export interface BonusCondition {
    actualBonus: number;
    calculatedBonus: number;
    memberBonus: number;
    mode: BonusConditionMode;
    title: string;
    value: number;
}

export enum BonusConditionMode {
    Amount = 'amount',
    Percentage = 'percentage',
}
